import React from 'react';

interface StepWelcomeProps {
  isProSubscriber: boolean;
  nextStep: () => void;
}

const StepWelcome = ({ nextStep, isProSubscriber }: StepWelcomeProps) => (
  <div className="onboarding-content center">
    <div>
      <h2 className="onboarding-heading large">
        Welcome to <br />
        The&nbsp;Information
        {isProSubscriber && <span className="text-pro-red"> Pro</span>}
      </h2>
      <p className="mt2 mb3">
        We&apos;re the leading publication high-powered tech executives and founders read daily.
      </p>
      <button
        onClick={nextStep}
        className="button button-red button-stretch button-small uppercase"
      >
        Get Started
      </button>
    </div>
  </div>
);

export default StepWelcome;
